import type { Breakpoints } from './config/breakpoints';
import breakpoints from './config/breakpoints';
import type { ColorScheme } from './config/colors';
import { COLOR_SCHEMES } from './config/colors';
import type { Sizes } from './config/sizes';
import sizes from './config/sizes';
import type { SpacingScheme } from './config/spacing';
import { radius, spacing } from './config/spacing';
import type { Text } from './config/text';
import text from './config/text';
import { THEME_NAMES } from './config/theme.constants';
import transition from './config/transition';

export interface AppTheme {
  themeColors: THEME_NAMES;
  themeSpacing: THEME_NAMES;
  activeColorScheme: ColorScheme;
  sizes: Sizes;
  spacing: SpacingScheme;
  breakpoints: Breakpoints;
  text: Text;
  transition: typeof transition;
}

export const getAppTheme = (themeName: THEME_NAMES): AppTheme => ({
  themeColors: themeName,
  themeSpacing: themeName,
  activeColorScheme: COLOR_SCHEMES[themeName],
  sizes,
  spacing: { ...spacing, ...radius },
  breakpoints,
  text,
  transition,
});

export const defaultTheme = getAppTheme(THEME_NAMES.DEFAULT);
